import React from 'react'
import Uploader from '../../Utils/uploader'
import { useFormik } from 'formik'
import { useSnackbar } from 'notistack'
import * as Yup from 'yup'
import VehicleImages from '../../Utils/VehicleImages'
import img1 from '../../assets/images/Car_image_1.svg'
import img2 from '../../assets/images/Car_image_2.svg'
import img3 from '../../assets/images/Car_image_3.svg'
import img4 from '../../assets/images/Car_image_4.svg'
import INimg3 from '../../assets/images/interior1.png'
import INimg4 from '../../assets/images/interior2.png'
import INimg5 from '../../assets/images/interior3.png'
import book1 from '../../assets/images/book1.png'
import book2 from '../../assets/images/book2.png'
import book3 from '../../assets/images/book3.png'
import book4 from '../../assets/images/book4.png'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const CarRegisterStepSec = ({
    details,
    trigger,
    location,
    setScreenChange,
    formik,
    nextStep,
    prevStep,
    setSkipOver,
    skipOver,
}) => {
    // Validation Schema
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()
    // const productSchema = Yup.object().shape({
    //     vehicle_interior: Yup.array()
    //         .min(5, 'Please upload at least 5 interior images')
    //         .required('Interior images are required'),
    //     vehicle_exterior: Yup.array()
    //         .min(5, 'Please upload at least 5 exterior images')
    //         .required('Exterior images are required'),
    //     service_book: Yup.array()
    //         .min(1, 'Please upload at least 1 service book document')
    //         .required('Service book document is required'),
    //     scratches_dents: Yup.array()
    //         .min(1, 'Please upload at least 1 image of scratches or dents')
    //         .required('Scratches/Dents images are required'),
    // })
    const vehicleExterior = [img1, img2, img3, img4]
    const vehicleInterior = [INimg3, INimg4, INimg5]
    const serviceBook = [book1, book2, book3, book4]

    const handleSkipClick = () => {
        setSkipOver(true)
        setTimeout(() => {
            nextStep()
        }, 0)
    }

    // // Formik Setup
    // const formik = useFormik({
    //     initialValues: {
    //         vehicle_interior: details?.vehicle_interior || [],
    //         vehicle_exterior: details?.vehicle_exterior || [],
    //         service_book: details?.service_book || [],
    //         scratches_dents: details?.scratches_dents || [],
    //     },
    //     validationSchema: productSchema,
    //     enableReinitialize: trigger,
    //     onSubmit: (values) => {
    //         if (values.vehicle_interior.length < 5) {
    //             return enqueueSnackbar('Please upload at least 5 interior images', {
    //                 variant: 'warning',
    //             })
    //         }
    //         if (values.vehicle_exterior.length < 5) {
    //             return enqueueSnackbar('Please upload at least 5 exterior images', {
    //                 variant: 'warning',
    //             })
    //         }
    //         if (values.service_book.length < 1) {
    //             return enqueueSnackbar('Please upload at least 1 service book document', {
    //                 variant: 'warning',
    //             })
    //         }
    //         if (values.scratches_dents.length < 1) {
    //             return enqueueSnackbar('Please upload at least 1 image of scratches/dents', {
    //                 variant: 'warning',
    //             })
    //         }

    //         // Store data in location state
    //         location.state = location.state
    //             ? { step1Data: values, step2Data: location.state.step2Data }
    //             : { step1Data: values }

    //         setScreenChange(1)
    //     },
    // })

    return (
        <>
            <h2 className="text-left light-white mb-3">{t('upload_pictures')}</h2>
            <p className="text-left">{t('upload_pictures_of_your_car')}</p>
            {/* <div className="d-flex justify-content-between">
                <p>Dont&apos;t wish to take now</p>
                <button
                    style={{
                        color: '#007776',
                        background: 'none',
                        border: 'none',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                    }}
                    onClick={handleSkipClick}
                >
                    Skip over
                </button>
            </div> */}
            <div className="cutomRadioButtons">
                <p className="label">{t('exterior')}</p>
                <div className="vehicle_exterior">
                    <VehicleImages
                        formik={formik}
                        name="vehicle_exterior"
                        titleText=""
                        innerText=""
                        folder="exterior"
                        imgCollection={vehicleExterior}
                        multiple={true}
                        reorder={true}
                        accept="image/*"
                    />
                </div>
                <p className="label">{t('interior')}</p>
                <div className="vehicle_exterior d-hideText">
                    <VehicleImages
                        formik={formik}
                        name="vehicle_interior"
                        titleText="upload "
                        innerText="uplaod1"
                        folder="interior"
                        imgCollection={vehicleInterior}
                        multiple={true}
                        reorder={true}
                        accept="image/*"
                    />
                </div>
                <p className="label">{t('service_book')}</p>
                <div className="vehicle_exterior d-hideTexts">
                    <VehicleImages
                        formik={formik}
                        name="service_book"
                        titleText="Upload images"
                        imgCollection={serviceBook}
                        innerText="dimensions"
                        folder="documents"
                        multiple={true}
                        reorder={true}
                        accept="image/*"
                    />
                </div>
                <p className="label mb-0">{t('scratches_and_dents')}</p>
                <span className="spntxt text-left mb-2 d-block">
                    {t('any_images_of_scratches_or_dents')}
                </span>
                <div className="vehicle_exterior">
                    <VehicleImages
                        formik={formik}
                        name="scratches_dents"
                        titleText={t('upload_pictures')}
                        innerText={`${t('recommended_dimensions')} ( 500px * 500px )`}
                        folder="damage"
                        multiple={true}
                        reorder={true}
                        accept="image/*"
                    />
                </div>

                {formik.errors.vehicle_interior && formik.touched.vehicle_interior && (
                    <div className="error-text">{formik.errors.vehicle_interior}</div>
                )}
                {formik.errors.vehicle_exterior && formik.touched.vehicle_exterior && (
                    <div className="error-text">{formik.errors.vehicle_exterior}</div>
                )}
                {/* {formik.errors.service_book && formik.touched.service_book && (
                    <div className="error-text">{formik.errors.service_book}</div>
                )}
                {formik.errors.scratches_dents && formik.touched.scratches_dents && (
                    <div className="error-text">{formik.errors.scratches_dents}</div>
                )} */}
                <PrimaryButton label={t('enter_a_price')} type="button" onClick={nextStep} />
            </div>
        </>
    )
}
